import { DELIVERED_DIGITAL_CERTIFICATE, DYNAMIC_DOWNLOADABLE_CERTIFICATE, PHYSICAL_DIPLOMA } from './constants';
import { type ProgramType, type ProgramTypeConfig } from './Program.types';
import { ProgramTypeConfigs } from './ProgramTypeConfigs';

export function getProgramTypeConfig(programType: string | undefined): ProgramTypeConfig | null {
    if (!programType || !(programType in ProgramTypeConfigs)) return null;
    return ProgramTypeConfigs[programType as ProgramType];
}

export function getProgramConfigValue<T>(programType: ProgramType, key: keyof ProgramTypeConfig) {
    const val = ProgramTypeConfigs[programType][key];
    if (val === undefined || val === null) {
        return null;
    }
    return val as T;
}

export function showsDiplomaCheckInWhenInFinishedState(programType: ProgramType) {
    return getProgramConfigValue(programType, 'completionDocumentType') === PHYSICAL_DIPLOMA;
}

export function showsCertificateCheckInWhenInFinishedState(programType: ProgramType) {
    return getProgramConfigValue(programType, 'completionDocumentType') === DELIVERED_DIGITAL_CERTIFICATE;
}

export function supportsDynamicDownloadableCertificate(programType: ProgramType) {
    const docType = getProgramConfigValue<string>(programType, 'completionDocumentType');
    return docType === DYNAMIC_DOWNLOADABLE_CERTIFICATE;
}

export const degreeProgramTypes = Object.keys(ProgramTypeConfigs).filter(
    programType => ProgramTypeConfigs[programType as ProgramType].isDegreeProgram,
) as ProgramType[];

export function supportsDiplomaGenerationDate(programType: ProgramType) {
    const docType = getProgramConfigValue<string>(programType, 'completionDocumentType');
    return docType === DELIVERED_DIGITAL_CERTIFICATE || docType === PHYSICAL_DIPLOMA;
}

export function supportsPhysicalDiploma(programType: ProgramType) {
    const docType = getProgramConfigValue<string>(programType, 'completionDocumentType');
    return docType === PHYSICAL_DIPLOMA;
}

export function supportsDeliveredDigitalCertificate(programType: ProgramType) {
    const docType = getProgramConfigValue<string>(programType, 'completionDocumentType');
    return docType === DELIVERED_DIGITAL_CERTIFICATE;
}

export function refersToGraduation(programType: ProgramType) {
    // We talk about "graduation" in programs that issue a diploma, but about "certificate completion"
    // or "program completion" in programs that do not
    const docType = getProgramConfigValue<string>(programType, 'completionDocumentType');
    return docType === PHYSICAL_DIPLOMA;
}

export function supportsCertificate(programType: ProgramType) {
    return supportsDeliveredDigitalCertificate(programType) || supportsDynamicDownloadableCertificate(programType);
}
